/* eslint-disable */
const $excel = this;

// Exports an array of objects (values) to Excel using fields as the column titles
$excel.export = function(values, fields, fileName, headers) {
  /* eslint-disable */
  const wb = XLSX.utils.book_new();

  if (!headers || !headers.length) headers = fields;
  const data = [headers];
  values.forEach(item => {
    const itemProps = [];
    fields.forEach(field => {
      itemProps.push(item[field]);
    });
    data.push(itemProps);
  });

  const ws = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, fileName.slice(0, 31));
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};
